export const isOfflineMode = () => {
  return window.location.protocol === "file:";
};
